import common from "@/common";
import { ForkstyleCommandEvent } from "./ForkstyleCommandEvent";
import { FMEventListenerAdded } from "./ForkstyleMessage";

const clearDataList = [] as ClearData[];
class ClearData{
  constructor(
    public target:Node,
    public eventName: string,
    public eventFunction?:EventListenerOrEventListenerObject ,
  ){
  }
}

//iframeで表示したコンテンツには、フォーカス中以外はキーイベントが送られない。
//このため、コンテンツが矢印キーで動作させる場合などに問題になるので、キーイベントをpostMessage経由で送る。
export const registerEventSend = (iframe:HTMLIFrameElement, eventRequest:FMEventListenerAdded) => {
  const eventClassOrIsHandle = getEventClassPermissionNecesaryOrIsHandleEvent(eventRequest);
  if(eventClassOrIsHandle === false) return;

  if(eventClassOrIsHandle === true || typeof (eventClassOrIsHandle as any).requestPermission !== 'function'){
    addEventToTarget(iframe, eventRequest);
    return;
  }

  (eventClassOrIsHandle as any).requestPermission().then((permissionState:string) => {
    if (permissionState === 'granted') {
      addEventToTarget(iframe, eventRequest);
    }else{  
      if(process.env.VUE_APP_MODE === "development")console.error("not granted:", permissionState);
    }
  }).catch((err:any)=>{
    if(process.env.VUE_APP_MODE === "development")console.error("permission error:", err);
  });
}

const getEventClassPermissionNecesaryOrIsHandleEvent = (eventRequest:FMEventListenerAdded):true|false|DeviceMotionEvent => {
  if(!eventRequest.eventName) return false;

  switch(eventRequest.eventName){
    case "keydown":
    case "keyup":
    case "keypress":
    case "gamepadconnected":
    case "gamepaddisconnected":
    case "languagechange":
    case "offline":
    case "online":
    case "wheel":
      return true;
    case "devicemotion":
      return DeviceMotionEvent as any;
    case "deviceorientation":
    case "deviceorientationabsolute":
      return DeviceOrientationEvent as any;
    default:
      return false;
  }
}

const addEventToTarget = (iframe:HTMLIFrameElement, eventRequest:FMEventListenerAdded) => {
  const targetElm = eventRequest.target === "window" ? window: document;

  const runFunction = createRunEvent(iframe, eventRequest.target);
  if(eventRequest.onPropertyUsed){
    (targetElm as any)["on" + eventRequest.eventName] = runFunction;
    clearDataList.push(new ClearData(targetElm as Node, eventRequest.eventName));
  }else{
    targetElm.addEventListener(eventRequest.eventName, runFunction)
    clearDataList.push(new ClearData(targetElm as Node, eventRequest.eventName, runFunction));
  }
}


const createRunEvent = (iframe:HTMLIFrameElement, targetName:string) => {
  return (e:Event) => {
    //異なるドメイン間では直接dispatchEventが呼び出せないのでpostMessageを使用する
    iframe.contentWindow?.postMessage({ 
      type: "forkstyle-command-event-dispatch",
      eventName:e.type,  
      eventInit: getEventInit(e),
      target: targetName,
    } as ForkstyleCommandEvent, "*");
  }
}

//eventオブジェクトをそのままpostMessageに渡すとエラーになるのでコピーする
//余計なオブジェクト（例えばwindowなど）が含まれてもエラーになるので、総当たりでプロパティをコピーもできないので指定する。
const getEventInit = (e:Event):EventInit => {
  switch(e.type){
    case "keydown":
    case "keyup":
    case "keypress":
      return common.copyProperties(e, [
        "charCode",
        "code",
        "isComposing",
        "key",
        "keyCode",
        "location",
        "repeat",
        "altKey",
        "ctrlKey",
        "metaKey",
        "modifierAltGraph",
        "modifierCapsLock",
        "modifierFn",
        "modifierFnLock",
        "modifierHyper",
        "modifierNumLock",
        "modifierScrollLock",
        "modifierSuper",
        "modifierSymbol",
        "modifierSymbolLock",
        "shiftKey",
        "bubbles",
        "cancelable",
        "composed",        
      ] as (keyof KeyboardEventInit)[])

    case "devicemotion":
      return common.copyProperties(e, [
        "acceleration",
        "accelerationIncludingGravity",
        "interval",
        "rotationRate",    
        "bubbles",
        "cancelable",
        "composed",
      ] as (keyof DeviceMotionEventInit)[])
    case "deviceorientation":
    case "deviceorientationabsolute":
      return common.copyProperties(e, [
        "absolute",
        "alpha",
        "beta",
        "gamma",    
        "bubbles",
        "cancelable",
        "composed",
      ] as (keyof DeviceOrientationEventInit)[])
      
    case "gamepadconnected":
    case "gamepaddisconnected":
      return common.copyProperties(e, [
        "gamepad",
        "bubbles",
        "cancelable",
        "composed",
      ] as (keyof GamepadEventInit)[])
      
    case "languagechange":
    case "offline":
    case "online":
      return common.copyProperties(e, [
        "bubbles",
        "cancelable",
        "composed",
      ] as (keyof EventInit)[])
    case "wheel":
      return common.copyProperties(e, [
        "deltaMode",
        "deltaX",
        "deltaY",
        "deltaZ",
        "button",
        "buttons",
        "clientX",
        "clientY",
        "movementX",
        "movementY",
        "relatedTarget",
        "screenX",
        "screenY",
        "altKey",
        "ctrlKey",
        "metaKey",
        "modifierAltGraph",
        "modifierCapsLock",
        "modifierFn",
        "modifierFnLock",
        "modifierHyper",
        "modifierNumLock",
        "modifierScrollLock",
        "modifierSuper",
        "modifierSymbol",
        "modifierSymbolLock",
        "shiftKey",
        "bubbles",
        "cancelable",
        "composed",
      ] as (keyof WheelEventInit)[])
    default:
      if(process.env.VUE_APP_MODE === "development")console.error("unexpected type event:", e);
      return {};
  }
}


export const clearEventSend = () => {
  clearDataList.forEach((data)=>{
    if(data.eventFunction){
      data.target.removeEventListener(data.eventName, data.eventFunction);
    }else{
      (data.target as any)["on" + data.eventName] = null;
    }
  })
}

